// src/layouts/ContentWrapper.jsx
import { Container } from "@mui/material";

export default function ContentWrapper({ children }) {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      {children}
    </Container>
  );
}
